import Draggable from "draggable";
import { Swiper } from "swiper";

import "./map.scss";

const selectors = {
  container: "[data-map]",
  mapContainer: "[data-map-container]",
  mapImage: "[data-map-image]",
  mapSwiper: "[data-map-swiper]",
  mapSlide: "[data-map-slide]",
  mapPin: "[data-map-pin]",
  mapPinMarker: "[data-map-pin-marker]",

  active: "active",
};

const initDraggable = (container) => {
  if (!container) return;

  const image = container.querySelector(selectors.mapImage);

  const options = {
    grid: 10,
    limit: {
      x: [
        container.getBoundingClientRect().width -
          image.getBoundingClientRect().width,
        0,
      ],
      y: [
        container.getBoundingClientRect().height -
          image.getBoundingClientRect().height,
        0,
      ],
    },
    onDragStart: (element) => element.style.setProperty("cursor", "grabbing"),
    onDragEnd: (element) => element.style.setProperty("cursor", "grab"),
  };

  return new Draggable(image, options);
};

const initMapSwiper = (swiper, pins, draggable) => {
  if (!swiper) return;

  const handleSlideChange = ({ activeIndex, slides }) => {
    if (!slides.length) return;

    const pin = pins.find(
      (pin) => pin.pin === slides[activeIndex]?.dataset.mapSlide
    );

    draggable.set(...pin.scrollTo);
  };

  new Swiper(swiper, {
    slidesPerView: "auto",
    spaceBetween: 8,

    on: {
      slideChange: handleSlideChange,
      init: handleSlideChange,
    },
  });
};

const handleMapPinMarkerClick = (activePin, pins, draggable) => {
  draggable.set(...activePin.scrollTo);

  pins.forEach((pin) => {
    pin.node.classList[pin.node.isSameNode(activePin.node) ? "add" : "remove"](
      selectors.active
    );
  });
};

const initMapPinMarkers = (pins, draggable) => {
  handleMapPinMarkerClick(pins[0], pins, draggable);

  pins.forEach((activePin) =>
    activePin.marker.addEventListener("click", () =>
      handleMapPinMarkerClick(activePin, pins, draggable)
    )
  );
};

const initMap = (container) => {
  const imageContainer = container.querySelector(selectors.mapContainer);
  const swiper = container.querySelector(selectors.mapSwiper);
  const pins = [...container.querySelectorAll(selectors.mapPin)].map((pin) => ({
    node: pin,
    pin: pin.dataset.mapPin,
    marker: pin.querySelector(selectors.mapPinMarker),
    scrollTo: [
      pin.offsetLeft * -1 + imageContainer.clientWidth / 3,
      pin.offsetTop * -1 + imageContainer.clientHeight / 3,
    ],
  }));

  const draggable = initDraggable(imageContainer);

  initMapSwiper(swiper, pins, draggable);
  initMapPinMarkers(pins, draggable);
};

document.addEventListener("DOMContentLoaded", async function () {
  const containers = document.querySelectorAll(selectors.container);

  containers?.forEach(initMap);
});
